"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureResourceManager = void 0;
/** {@inheritDoc IFeatureResourceManager} */

var FeatureResourceManager = /*#__PURE__*/function () {
  function FeatureResourceManager() {
    _classCallCheck(this, FeatureResourceManager);

    this.resources = {};
  }

  _createClass(FeatureResourceManager, [{
    key: "resourceKey",
    value: function resourceKey(resource) {
      return [resource.type, resource.identifier].join('|');
    }
  }, {
    key: "resourceKeyFromStrings",
    value: function resourceKeyFromStrings(type, identifier) {
      return [type, identifier].join('|');
    }
    /** {@inheritDoc IFeatureResourceManager.addResource} */

  }, {
    key: "addResource",
    value: function addResource(resource) {
      var storedResource = resource;

      if (!storedResource.identifier) {
        throw new Error("Resource of type '".concat(resource.type, "' is missing an identifier."));
      }

      if (this.getResource(storedResource.type, storedResource.identifier)) {
        throw new Error("Resource '".concat(storedResource.identifier, "' has already been defined."));
      }

      this.resources[this.resourceKey(storedResource)] = storedResource;
    }
    /** {@inheritDoc IFeatureResourceManager.getResource} */

  }, {
    key: "getResource",
    value: function getResource(type, identifier) {
      var resource = this.resources[this.resourceKeyFromStrings(type, identifier)];
      return resource ? resource : null;
    }
    /** {@inheritDoc IFeatureResourceManager.getResourcesForType} */

  }, {
    key: "getResourcesForType",
    value: function getResourcesForType(type) {
      return Object.values(this.resources).filter(function (resource) {
        return resource.type === type;
      });
    }
  }]);

  return FeatureResourceManager;
}();

exports.FeatureResourceManager = FeatureResourceManager;